import { NavigationExtras } from '@angular/router';
import { IEMRLayout } from '@care-portals/api-interfaces';

const ORG_QUERY_PARAM = 'org';
export const SELECTED_LAYOUT_KEY = 'selected_layout';

export const getActiveOrg = (): string | null =>
  localStorage.getItem(SELECTED_LAYOUT_KEY);

export const getOrgAwareMenuQueryParams = (): { org: string } | Record<string, never> => {
  const org = getActiveOrg();
  return org ? { org } : {};
};

export const normalizeMenuLink = (link: string): string =>
  ('/' + (link || '').replace(/^\/+/, '')).replace(/\/+/g, '/');

export const resolveOrgFromUrl = (appLayouts: IEMRLayout[]): string | null => {
  const orgFromQuery = new URLSearchParams(window.location.search).get(
    ORG_QUERY_PARAM
  );
  if (!orgFromQuery) return null;

  const isValidOrg = appLayouts.some(
    layout => layout.organization === orgFromQuery
  );
  if (!isValidOrg) return null;

  return orgFromQuery;
};

export const setOrgQueryParam = (org: string): void => {
  const url = new URL(window.location.href);
  url.searchParams.set(ORG_QUERY_PARAM, org);
  window.history.replaceState({}, '', url.toString());
};

/** For router.navigateByUrl only — not for grid routerLink columns. */
export const buildOrgAwareUrl = (path: string): string => {
  const normalized = normalizeMenuLink(path);

  const org = getActiveOrg();
  if (!org) return normalized;

  const url = new URL(normalized, window.location.origin);
  url.searchParams.set(ORG_QUERY_PARAM, org);
  return url.pathname + url.search;
};

export const withOrgNavigationExtras = (
  extras?: NavigationExtras
): NavigationExtras => {
  const org = getActiveOrg();
  if (!org) return extras ?? {};

  return {
    ...extras,
    queryParams: { org, ...extras?.queryParams },
    queryParamsHandling: extras?.queryParamsHandling ?? 'merge'
  };
};
